var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"wow fadeInUp",class:{ current: _vm.currentTab.selected },attrs:{"data-filter":_vm.filter,"data-wow-duration":"0.8s","data-wow-delay":"0.2s"},on:{"click":_vm.switchTab}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }